<template>
  <!-- 服务器菜单 -->
  <div>
    <!-- 查询 -->
    <Form :model="searchItem" inline style="width:100%" class='header_form'>
      <!-- 项目 -->
      <FormItem :label="$t('module.text54')+':'">
        <Select v-model="searchItem.projectid" clearable filterable>
          <Option v-for="item in searchProjects" :value="item.num" :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <!-- 查询 -->
      <FormItem>
        <Button type="primary" @click="searchDep">{{$t('golbal.text25')}}</Button>
      </FormItem>
      <!-- 添加 -->
      <FormItem>
        <Button type="primary" icon="md-add" @click="addDep" v-if="buttonA"></Button>
      </FormItem>
    </Form>

    <div>
      <!-- 添加 -->
      <Modal style="text-align:center" footer-hide v-model="modal1" :title="$t('golbal.text85')" @on-cancel="cancel">
        <Form ref="addref" :rules="addrules" :model="addItem" :label-width="120">
          <FormItem :label="$t('module.text241')" prop="devicecode">
            <Input v-model="addItem.devicecode"></Input>
          </FormItem>
          <FormItem :label="$t('golbal.text38')+':'" prop="descr">
            <Input v-model="addItem.descr"></Input>
          </FormItem>
        </Form>
        <Button type="error" @click="cancel" style="margin-right:30px">{{$t('golbal.text20')}}</Button>
        <Button type="success" @click="ok">
          <span v-if="!Buttonloading">{{$t('golbal.text13')}}</span>
          <span v-else>{{$t('golbal.text24')}}</span>
        </Button>
      </Modal>
    </div>

    <!-- table -->
    <Table border :height="tableHeight" :columns="columns12" :data="data6" :loading="loading" ref="selection" :no-data-text="$t('golbal.text21')">
      <template slot-scope="{ row }" slot="name">
        <strong>{{ row.name }}</strong>
      </template>
    </Table>
    <!-- 尾部 -->
    <Footer id="footer" style="position: absolute;bottom: 0;width: 100%;padding:0px;z-index:100">
      <!-- 分页 -->
      <Page class="page" :current="searchItem.page" :page-size-opts="Psize" :total="total" :page-size="searchItem.limit" @on-change="ChangePage" @on-page-size-change="ChangePageSize" show-sizer />

    </Footer>
  </div>
  <!-- 单位查询 -->
</template>
<script>
import {
  searchModel,
  addModel,
  DelModel,
  findserver,
  addserverinfo
} from '../../../service/getData'
// import { stringify } from 'querystring';
export default {
  data() {
    return {
      // 查询条件
      searchItem: {
        page: 1, //页码
        limit: 15, //条数
        projectid: '' //项目工号
      },
      // 添加条件
      addItem: {
        devicecode: '', //机器码
        descr: '' //备注
      },

      Psize: [15, 20, 25, 100], // 条数选择
      tableHeight: 700, //table表格高度
      removeId: [], //选中删除单位
      remoloading: false, //控制删除按钮
      total: 100, // 总条数
      loading: true, //加载状态
      data6: [], // tab数据
      Buttonloading: false,
      modal1: false,

      columns12: [
        {
          title: this.$t('module.text241'),
          key: 'devicecode',
          align: 'center'
        },
        {
          title: this.$t('golbal.text44'),
          key: 'projectname',
          align: 'center'
        },
        {
          title: this.$t('module.text242'),
          key: 'lisensi',
          align: 'center',
          render: (h, params) => {
            return h(
              'Tooltip',
              {
                style: {
                  color: '#19be6b',
                  cursor: 'pointer'
                },
                props: {
                  content: params.row.lisensi,
                  // placement:"bottom",
                  maxWidth: 500
                }
              },
              this.$t('golbal.text27')
            )
          }
        },
        {
          title: this.$t('module.text264'),
          key: 'recorddate',
          align: 'center'
        },
        {
          title: this.$t('module.text265'),
          key: 'username',
          align: 'center'
        },
        {
          title: this.$t('golbal.text38'),
          key: 'descr',
          align: 'center'
        }
      ],
      // 添加验证
      addrules: {
        devicecode: [
          {
            required: true,
            message: this.$t('golbal.text67') + this.$t('module.text241'),
            trigger: 'blur'
          }
        ],
        descr: [
          {
            required: true,
            message: this.$t('golbal.text67') + this.$t('golbal.text38'),
            trigger: 'blur',
            trigger: 'blur'
          }
        ]
      },

      // 用户展示(权限类)
      buttonA: false, //新增
      buttonB: false, //删除
      buttonC: false //修改
    }
  },
  computed: {
    // 所有单位
    Unitpagings() {
      return this.$store.state.Unitpagings
    },
    // 所有角色
    Queryroles() {
      return this.$store.state.Queryroles
    },
    // 所有品牌
    searchBrand() {
      return this.$store.state.searchBrand
    },
    // 页面按钮权限
    buttonAll() {
      return this.$store.state.buttonAll
    },
    // 页面按钮权限
    searchProjects() {
      return this.$store.state.searchProjects
    }
  },
  created() {
    // 页面按钮权限
    if (this.buttonAll.includes('EquipmentTypeAdd')) {
      this.buttonA = true
    }
    if (this.buttonAll.includes('EquipmentTypeDel')) {
      this.buttonB = true
    }
    if (this.buttonAll.includes('EquipmentTypeUp')) {
      this.buttonC = true
    }
    // 调用封装分页查询
    this.getUnitpaging(this.searchItem)
  },
  methods: {
    // 查询
    searchDep() {
      this.loading = false
      this.searchItem.page = 1
      this.getUnitpaging(this.searchItem)
    },

    // 页面刷新
    Refresh() {
      this.loading = false
      this.searchItem.page = 1
      this.getUnitpaging(this.searchItem)
    },

    // 封装分页查询
    getUnitpaging(data) {
      findserver(data).then((res) => {
        if (res.data.code == 200) {
          this.$Message.destroy()
          this.$Message.success(this.$t('golbal.text14'))
          this.loading = false
          this.data6 = res.data.data.list
          this.total = res.data.data.total
        } else if (res.data.code == 1000003) {
          this.$Message.destroy()
          this.$Message.error(res.data.msg)
          this.loading = false
        }
      })
    },

    // 改变页码
    ChangePage(page) {
      this.searchItem.page = page
      this.loading = true
      this.getUnitpaging(this.searchItem)
    },

    // 改变每页数量
    ChangePageSize(size) {
      const Size = size
      this.searchItem.limit = Size
      this.loading = true
      this.getUnitpaging(this.searchItem)
    },

    // 点击新增按钮
    addDep() {
      this.modal1 = true
    },
    // 添加取消
    cancel() {
      this.$Message.info(this.$t('golbal.text16'))
      this.modal1 = false
      // 重置
      this.$refs.addref.resetFields()
    },
    // 添加
    ok() {
      this.$refs.addref.validate((valid) => {
        if (valid) {
          addserverinfo(this.addItem).then((res) => {
            if (res.data.code == 200) {
              this.Buttonloading = false
              this.$Message.destroy()
              this.$Message.success(this.$t('golbal.text17'))
              this.$store.dispatch('getsearchModels')
              this.modal1 = false
              // 重置
              this.$refs.addref.resetFields()
              const that1 = this
              // 延时刷新
              setTimeout(() => {
                that1.loading = true
                that1.getUnitpaging(that1.searchItem)
              }, 1000)
            } else {
              this.Buttonloading = false
              this.$Message.destroy()
              this.$Message.error(res.data.msg)
              this.modal1 = false
              // 重置
              this.$refs.addref.resetFields()
            }
          })
        } else {
          this.Buttonloading = false
          this.Buttonloading = false
          this.$Message.error(this.$t('golbal.text18'))
        }
      })
    }
  },
  mounted() {
    // 设置表格高度
    this.tableHeight =
      document.body.clientHeight -
      document.getElementById('footer').offsetHeight -
      165

    window.onresize = () => {
      return (() => {
        this.tableHeight =
          document.body.clientHeight -
          document.getElementById('footer').offsetHeight -
          165
      })()
    }
  }
}
</script>
<style  scoped>
.header_form {
  display: flex;
  flex-wrap: wrap;
}
.header_form .ivu-form-item {
  display: flex;
}
.header_form .ivu-form-item .ivu-form-item-label {
  padding: 0px 5px;
}
.header_form .ivu-form-item .ivu-form-item-content {
  margin: 0px 5px;
}
</style>
